import { render } from "./Tienda.vue?vue&type=template&id=1d64bec6"
import script from "./Tienda.vue?vue&type=script&lang=ts"
export * from "./Tienda.vue?vue&type=script&lang=ts"
script.render = render

export default script